(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bw-hero-iframe]').forEach((iframe) => {
    const revealIframe = () => {
      window.setTimeout(() => iframe.classList.add('is-loaded'), 1600);
    };

    if (iframe.classList.contains('is-loaded')) {
      return;
    }

    iframe.addEventListener('load', revealIframe, { once: true });
    window.setTimeout(() => iframe.classList.add('is-loaded'), 2600);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.pm-contact').forEach((section) => {
      if (section.classList.contains('pm-contact--tour')) {
        const preferenceInput = section.querySelector('[data-tour-preference-input]');
        const preferenceOptions = [...section.querySelectorAll('[data-tour-preference-option]')];
        const setPreference = (value) => {
          if (preferenceInput) preferenceInput.value = value;
          preferenceOptions.forEach((option) => option.setAttribute('aria-pressed', String(option.dataset.value === value)));
        };
        preferenceOptions.forEach((option) => option.addEventListener('click', () => setPreference(option.dataset.value)));

        const datePicker = section.querySelector('[data-tour-date-picker]');
        const dateTrigger = datePicker?.querySelector('[data-tour-date-trigger]');
        const datePanel = datePicker?.querySelector('[data-tour-calendar]');
        const dateInput = datePicker?.querySelector('[data-tour-date-input]');
        const dateValue = datePicker?.querySelector('[data-tour-date-value]');
        const monthLabel = datePicker?.querySelector('[data-tour-calendar-month]');
        const daysGrid = datePicker?.querySelector('[data-tour-calendar-days]');
        const prevMonth = datePicker?.querySelector('[data-tour-calendar-prev]');
        const nextMonth = datePicker?.querySelector('[data-tour-calendar-next]');
        const clearDate = datePicker?.querySelector('[data-tour-date-clear]');
        const todayDate = datePicker?.querySelector('[data-tour-date-today]');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        let calendarMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        const localIsoDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };
        const prettyDate = (date) => new Intl.DateTimeFormat('en-AU', {
          weekday: 'short', day: 'numeric', month: 'long', year: 'numeric'
        }).format(date);
        const closeDatePicker = () => {
          if (!datePanel || !dateTrigger) return;
          datePanel.hidden = true;
          dateTrigger.setAttribute('aria-expanded', 'false');
        };
        const selectDate = (date) => {
          if (dateInput) dateInput.value = localIsoDate(date);
          if (dateValue) dateValue.textContent = prettyDate(date);
          closeDatePicker();
        };
        const renderCalendar = () => {
          if (!monthLabel || !daysGrid) return;
          monthLabel.textContent = new Intl.DateTimeFormat('en-AU', { month: 'long', year: 'numeric' }).format(calendarMonth);
          daysGrid.replaceChildren();
          const startOffset = (calendarMonth.getDay() + 6) % 7;
          const monthDays = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 0).getDate();
          for (let index = 0; index < startOffset; index += 1) daysGrid.append(document.createElement('span'));
          for (let day = 1; day <= monthDays; day += 1) {
            const date = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth(), day);
            const button = document.createElement('button');
            const iso = localIsoDate(date);
            button.type = 'button';
            button.textContent = String(day);
            button.disabled = date < today;
            button.setAttribute('aria-label', prettyDate(date));
            button.setAttribute('aria-selected', String(dateInput?.value === iso));
            button.addEventListener('click', () => selectDate(date));
            daysGrid.append(button);
          }
          if (prevMonth) prevMonth.disabled = calendarMonth <= new Date(today.getFullYear(), today.getMonth(), 1);
        };
        dateTrigger?.addEventListener('click', () => {
          const opening = Boolean(datePanel?.hidden);
          if (datePanel) datePanel.hidden = !opening;
          dateTrigger.setAttribute('aria-expanded', String(opening));
          if (opening) renderCalendar();
        });
        prevMonth?.addEventListener('click', () => {
          calendarMonth = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() - 1, 1);
          renderCalendar();
        });
        nextMonth?.addEventListener('click', () => {
          calendarMonth = new Date(calendarMonth.getFullYear(), calendarMonth.getMonth() + 1, 1);
          renderCalendar();
        });
        clearDate?.addEventListener('click', () => {
          if (dateInput) dateInput.value = '';
          if (dateValue) dateValue.textContent = 'Choose a date';
          closeDatePicker();
        });
        todayDate?.addEventListener('click', () => selectDate(today));

        const timePicker = section.querySelector('[data-tour-time-picker]');
        const timeTrigger = timePicker?.querySelector('[data-tour-time-trigger]');
        const timeList = timePicker?.querySelector('[data-tour-time-list]');
        const timeInput = timePicker?.querySelector('[data-tour-time-input]');
        const timeValue = timePicker?.querySelector('[data-tour-time-value]');
        const timeOptions = [...(timePicker?.querySelectorAll('[data-tour-time-option]') || [])];
        const closeTimePicker = () => {
          if (!timeList || !timeTrigger) return;
          timeList.hidden = true;
          timeTrigger.setAttribute('aria-expanded', 'false');
        };
        timeTrigger?.addEventListener('click', () => {
          const opening = Boolean(timeList?.hidden);
          if (timeList) timeList.hidden = !opening;
          timeTrigger.setAttribute('aria-expanded', String(opening));
          if (opening) timeOptions[0]?.focus();
        });
        timeOptions.forEach((option) => option.addEventListener('click', () => {
          if (timeInput) timeInput.value = option.dataset.value;
          if (timeValue) timeValue.textContent = option.dataset.label;
          timeOptions.forEach((candidate) => candidate.setAttribute('aria-selected', String(candidate === option)));
          closeTimePicker();
          timeTrigger?.focus();
        }));

        document.addEventListener('click', (event) => {
          if (datePicker && !datePicker.contains(event.target)) closeDatePicker();
          if (timePicker && !timePicker.contains(event.target)) closeTimePicker();
        });
        section.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          closeDatePicker();
          closeTimePicker();
        });
      }

      const dialog = section.querySelector('[data-boat-selector]');
      const openButton = section.querySelector('[data-boat-selector-open]');
      const closeButton = section.querySelector('[data-boat-selector-close]');
      const skipButton = section.querySelector('[data-boat-selector-skip]');
      const input = section.querySelector('[data-boat-selection-input]');
      const label = section.querySelector('[data-boat-selector-label]');
      const summary = section.querySelector('[data-boat-selection-summary]');
      if (!dialog || !openButton || !input || !label || !summary) return;

      const initialLabel = label.innerHTML;
      const searchInput = section.querySelector('[data-boat-search]');
      const brandFilter = section.querySelector('[data-boat-brand-filter]');
      const resultsCount = section.querySelector('[data-boat-results-count]');
      const emptyState = section.querySelector('[data-boat-empty]');
      const allChoices = [...section.querySelectorAll('[data-boat-choice]')];
      const seenTitles = new Set();
      const choices = allChoices.filter((choice) => {
        const titleKey = (choice.dataset.boatTitle || '').trim().toLocaleLowerCase();
        if (titleKey && seenTitles.has(titleKey)) {
          choice.hidden = true;
          choice.dataset.boatDuplicate = 'true';
          return false;
        }
        if (titleKey) seenTitles.add(titleKey);
        return true;
      });

      if (brandFilter) {
        [...new Set(choices.map((choice) => choice.dataset.boatBrand).filter(Boolean))]
          .sort((a, b) => a.localeCompare(b))
          .forEach((brand) => brandFilter.add(new Option(brand, brand)));
      }

      const filterChoices = () => {
        const query = (searchInput?.value || '').trim().toLocaleLowerCase();
        const brand = brandFilter?.value || '';
        let visibleCount = 0;
        choices.forEach((choice) => {
          const searchable = `${choice.dataset.boatTitle || ''} ${choice.dataset.boatBrand || ''}`.toLocaleLowerCase();
          const visible = (!query || searchable.includes(query)) && (!brand || choice.dataset.boatBrand === brand);
          choice.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        if (resultsCount) resultsCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'boat' : 'boats'}`;
        if (emptyState) emptyState.hidden = visibleCount !== 0;
      };

      searchInput?.addEventListener('input', filterChoices);
      brandFilter?.addEventListener('change', filterChoices);
      filterChoices();
      const syncDialogScrollLock = () => {
        const hasOpenBoatSelector = Boolean(document.querySelector('[data-boat-selector][open]'));
        document.documentElement.classList.toggle('pm-boat-selector-is-open', hasOpenBoatSelector);
      };
      const openDialog = () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        syncDialogScrollLock();
      };
      const closeDialog = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        syncDialogScrollLock();
      };
      const setSelection = ({ title = '', url = '', handle = '' } = {}) => {
        if (!title && !handle) {
          input.value = '';
          label.innerHTML = initialLabel;
          summary.hidden = true;
          summary.textContent = '';
          return;
        }
        const displayTitle = title || handle.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
        const absoluteUrl = url ? new URL(url, window.location.origin).href : `${window.location.origin}/products/${handle}`;
        input.value = `${displayTitle} — ${absoluteUrl}`;
        label.textContent = displayTitle;
        summary.hidden = false;
        summary.textContent = section.classList.contains('pm-contact--tour')
          ? 'Selected for this viewing. Choose again to change it.'
          : 'Selected for this enquiry. Choose again to change it.';
      };

      openButton.addEventListener('click', openDialog);
      closeButton?.addEventListener('click', closeDialog);
      skipButton?.addEventListener('click', () => {
        setSelection();
        closeDialog();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('close', syncDialogScrollLock);
      section.querySelectorAll('[data-boat-choice]').forEach((choice) => {
        choice.addEventListener('click', () => {
          setSelection({
            title: choice.dataset.boatTitle,
            url: choice.dataset.boatUrl,
            handle: choice.dataset.boatHandle
          });
          closeDialog();
        });
      });

      const requestedHandle = new URLSearchParams(window.location.search).get('boat');
      const requestedTitle = new URLSearchParams(window.location.search).get('boat_title');
      if (requestedHandle || requestedTitle) {
        const matchingChoice = [...section.querySelectorAll('[data-boat-choice]')]
          .find((choice) => choice.dataset.boatHandle === requestedHandle || choice.dataset.boatTitle === requestedTitle);
        setSelection({
          title: matchingChoice?.dataset.boatTitle || requestedTitle || '',
          url: matchingChoice?.dataset.boatUrl || '',
          handle: matchingChoice?.dataset.boatHandle || requestedHandle || ''
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const shouldAnimate = !this.header.classList.contains('shopify-section-header-hidden');
      this.header.classList.toggle('animate', shouldAnimate);
      this.header.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const gateway = document.querySelector('[data-enquiry-gateway]');
    const openers = [...document.querySelectorAll('[data-enquiry-gateway-open]')];
    const closeButton = gateway?.querySelector('[data-enquiry-gateway-close]');
    if (!gateway || !openers.length || !closeButton) return;

    document.body.appendChild(gateway);
    let opener = null;
    let gatewayScrollPosition = 0;

    const closeGateway = () => {
      gateway.classList.remove('is-open');
      gateway.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('enquiry-gateway-is-open');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('right');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('width');
      window.scrollTo(0, gatewayScrollPosition);
      opener?.focus({ preventScroll: true });
      opener = null;
    };

    const openGateway = (trigger) => {
      opener = trigger;
      gatewayScrollPosition = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${gatewayScrollPosition}px`;
      document.body.style.right = '0';
      document.body.style.left = '0';
      document.body.style.width = '100%';
      gateway.classList.add('is-open');
      gateway.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('enquiry-gateway-is-open');
      window.setTimeout(() => closeButton.focus({ preventScroll: true }), 40);
    };

    openers.forEach((trigger) => trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openGateway(trigger);
    }));
    closeButton.addEventListener('click', closeGateway);

    gateway.addEventListener('click', (event) => {
      if (event.target === gateway) closeGateway();
    });

    gateway.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeGateway();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...gateway.querySelectorAll('button, a[href]')].filter((element) => element.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inventory-grid"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.inventory__toolbar .mobile-facets__disclosure').forEach((drawer) => {
      const updateScrollLock = () => {
        document.documentElement.classList.toggle('pm-filter-modal-open', drawer.open);
      };

      drawer.addEventListener('toggle', updateScrollLock);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owner-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testimonial-slider]').forEach((slider) => {
    const rail = slider.querySelector('[data-testimonial-rail]');
    const slides = Array.from(rail?.children || []);
    const index = slider.querySelector('[data-testimonial-index]');
    const prev = slider.querySelector('[data-testimonial-prev]');
    const next = slider.querySelector('[data-testimonial-next]');
    if (!rail || !slides.length) return;

    let active = 0;
    const update = () => {
      rail.scrollTo({ left: slides[active].offsetLeft, behavior: 'smooth' });
      if (index) index.textContent = `${active + 1} / ${slides.length}`;
    };

    prev?.addEventListener('click', () => {
      active = (active - 1 + slides.length) % slides.length;
      update();
    });
    next?.addEventListener('click', () => {
      active = (active + 1) % slides.length;
      update();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-listing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.yacht');
    if (!root) return;

    const slides = [...root.querySelectorAll('[data-slide-index]')];
    const dots = [...root.querySelectorAll('[data-yacht-dot]')];
    const current = root.querySelector('[data-yacht-current]');
    const hero = root.querySelector('.yacht-hero');
    const mobileCta = root.querySelector('.yacht-mobile-cta');
    const enquiryPanel = root.querySelector('#enquire');
    const enquiryTitle = enquiryPanel?.querySelector('.yacht-sheet__mobile-header h2');
    const enquiryMedia = window.matchMedia('(max-width: 989px)');
    let enquiryOpener = null;
    let index = 0;

    const closeEnquiry = ({ restoreFocus = true } = {}) => {
      if (!enquiryPanel) return;
      enquiryPanel.classList.remove('is-open');
      document.documentElement.classList.remove('yacht-enquiry-is-open');

      if (enquiryMedia.matches) {
        enquiryPanel.setAttribute('aria-hidden', 'true');
      } else {
        enquiryPanel.removeAttribute('aria-hidden');
        enquiryPanel.removeAttribute('role');
        enquiryPanel.removeAttribute('aria-modal');
        enquiryPanel.removeAttribute('aria-labelledby');
      }

      if (restoreFocus && enquiryOpener) enquiryOpener.focus({ preventScroll: true });
      enquiryOpener = null;
    };

    const openEnquiry = (opener) => {
      if (!enquiryPanel || !enquiryMedia.matches) return;
      enquiryOpener = opener || document.activeElement;
      enquiryPanel.setAttribute('role', 'dialog');
      enquiryPanel.setAttribute('aria-modal', 'true');
      if (enquiryTitle?.id) enquiryPanel.setAttribute('aria-labelledby', enquiryTitle.id);
      enquiryPanel.setAttribute('aria-hidden', 'false');
      enquiryPanel.classList.add('is-open');
      document.documentElement.classList.add('yacht-enquiry-is-open');
      const closeButton = enquiryPanel.querySelector('[data-yacht-enquiry-close]:not(.yacht-aside__backdrop)');
      requestAnimationFrame(() => closeButton?.focus({ preventScroll: true }));
      window.setTimeout(() => closeButton?.focus({ preventScroll: true }), 50);
    };

    const syncEnquiryMode = () => {
      if (!enquiryPanel) return;
      if (enquiryMedia.matches) {
        if (!enquiryPanel.classList.contains('is-open')) enquiryPanel.setAttribute('aria-hidden', 'true');
      } else {
        closeEnquiry({ restoreFocus: false });
      }
    };

    root.querySelectorAll('a[href="#enquire"]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (!enquiryMedia.matches) return;
        event.preventDefault();
        openEnquiry(trigger);
      });
    });

    enquiryPanel?.querySelectorAll('[data-yacht-enquiry-close]').forEach((button) => {
      button.addEventListener('click', () => closeEnquiry());
    });

    enquiryPanel?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeEnquiry();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = [...enquiryPanel.querySelectorAll('button, a[href], input, textarea, select, [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.disabled && element.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    enquiryMedia.addEventListener?.('change', syncEnquiryMode);
    syncEnquiryMode();

    if (enquiryPanel?.querySelector('.yacht-sheet__success') && enquiryMedia.matches) {
      openEnquiry(mobileCta?.querySelector('a'));
    }

    if (mobileCta && 'IntersectionObserver' in window) {
      const overlapTargets = [
        root.querySelector('.yacht-source__actions'),
        document.querySelector('footer')
      ].filter(Boolean);
      const visibleTargets = new Map(overlapTargets.map((target) => [target, false]));
      const overlapObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => visibleTargets.set(entry.target, entry.isIntersecting));
        mobileCta.classList.toggle('is-suppressed', [...visibleTargets.values()].some(Boolean));
      }, { threshold: 0.01 });

      overlapTargets.forEach((target) => overlapObserver.observe(target));
    }

    const show = (next) => {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (current) current.textContent = String(index + 1);
    };

    root.querySelector('[data-yacht-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-yacht-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.yachtDot))));

    let touchStartX = 0;
    hero?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    hero?.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) > 50) show(index + (distance < 0 ? 1 : -1));
    }, { passive: true });

    root.querySelector('[data-yacht-share]')?.addEventListener('click', async () => {
      const data = { title: document.title, url: window.location.href };
      if (navigator.share) {
        await navigator.share(data).catch(() => {});
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(data.url);
      }
    });

    const videoDialog = root.querySelector('[data-yacht-video-dialog]');
    const videoFrame = videoDialog?.querySelector('[data-yacht-video-frame]');
    let videoOpener = null;

    const getVideoEmbedUrl = (source) => {
      if (!source) return '';

      try {
        const url = new URL(source, window.location.origin);
        const hostname = url.hostname.replace(/^www\./, '');

        if (hostname === 'youtu.be' || hostname === 'youtube.com' || hostname === 'm.youtube.com') {
          const videoId = hostname === 'youtu.be'
            ? url.pathname.split('/').filter(Boolean)[0]
            : url.searchParams.get('v') || url.pathname.match(/\/(?:embed|shorts)\/([^/?]+)/)?.[1];

          if (videoId) {
            const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
            url.searchParams.forEach((value, key) => {
              if (key !== 'v') embedUrl.searchParams.set(key, value);
            });
            embedUrl.searchParams.set('autoplay', '1');
            embedUrl.searchParams.set('rel', '0');
            return embedUrl.toString();
          }
        }

        if (hostname === 'vimeo.com' || hostname === 'player.vimeo.com') {
          const videoId = url.pathname.match(/(?:video\/)?(\d+)/)?.[1];
          if (videoId) return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        }

        return url.toString();
      } catch (error) {
        return source;
      }
    };

    const closeVideo = () => {
      if (!videoDialog) return;
      if (videoDialog.open && typeof videoDialog.close === 'function') videoDialog.close();
      else videoDialog.removeAttribute('open');
    };

    root.querySelector('[data-yacht-video-open]')?.addEventListener('click', (event) => {
      if (!videoDialog || !videoFrame) return;
      videoOpener = event.currentTarget;
      videoFrame.src = getVideoEmbedUrl(event.currentTarget.dataset.yachtVideoSrc);
      if (typeof videoDialog.showModal === 'function') videoDialog.showModal();
      else videoDialog.setAttribute('open', '');
      document.documentElement.classList.add('yacht-video-is-open');
      videoDialog.querySelector('[data-yacht-video-close]')?.focus({ preventScroll: true });
    });

    videoDialog?.querySelector('[data-yacht-video-close]')?.addEventListener('click', closeVideo);
    videoDialog?.addEventListener('click', (event) => {
      if (event.target === videoDialog) closeVideo();
    });
    videoDialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeVideo();
    });
    videoDialog?.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeVideo();
    });
    videoDialog?.addEventListener('close', () => {
      if (videoFrame) videoFrame.src = '';
      document.documentElement.classList.remove('yacht-video-is-open');
      videoOpener?.focus({ preventScroll: true });
      videoOpener = null;
    });

    const galleryDialog = root.querySelector('[data-yacht-gallery-dialog]');
    const openGallery = () => {
      if (!galleryDialog) return;
      if (typeof galleryDialog.showModal === 'function') galleryDialog.showModal();
      else galleryDialog.setAttribute('open', '');
      document.documentElement.classList.add('yacht-gallery-is-open');
      galleryDialog.querySelector('[data-yacht-gallery-close]')?.focus();
    };
    const closeGallery = () => {
      if (!galleryDialog) return;
      if (typeof galleryDialog.close === 'function') galleryDialog.close();
      else galleryDialog.removeAttribute('open');
      document.documentElement.classList.remove('yacht-gallery-is-open');
    };

    root.querySelectorAll('[data-yacht-gallery-open]').forEach((button) => button.addEventListener('click', openGallery));
    galleryDialog?.querySelector('[data-yacht-gallery-close]')?.addEventListener('click', closeGallery);
    galleryDialog?.addEventListener('click', (event) => {
      if (event.target === galleryDialog) closeGallery();
    });
    galleryDialog?.addEventListener('close', () => document.documentElement.classList.remove('yacht-gallery-is-open'));

    const related = root.querySelector('[data-related-carousel]');
    if (related) {
      const relatedSlides = [...related.querySelectorAll('[data-related-slide]')];
      const relatedDots = [...related.querySelectorAll('[data-related-dot]')];
      let relatedIndex = 0;

      const showRelated = (next) => {
        if (!relatedSlides.length) return;
        relatedIndex = (next + relatedSlides.length) % relatedSlides.length;
        relatedSlides.forEach((slide, slideIndex) => {
          const active = slideIndex === relatedIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        relatedDots.forEach((dot, dotIndex) => {
          const active = dotIndex === relatedIndex;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      related.querySelector('[data-related-prev]')?.addEventListener('click', () => showRelated(relatedIndex - 1));
      related.querySelector('[data-related-next]')?.addEventListener('click', () => showRelated(relatedIndex + 1));
      relatedDots.forEach((dot) => dot.addEventListener('click', () => showRelated(Number(dot.dataset.relatedDot))));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
